import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Inline, Stack } from 'syf-component-library/ui/spacing';
import { colors } from 'syf-component-library/defaultTheme';
import { useTranslation } from 'react-i18next';
import { FAS_CHECK_CIRCLE, Icon } from '@account-services-mfe/core';
import qualifiedEventItems from './qualified-event-items';
import QualifiedEventItemsContainer from './subcomponents';
const QualifiedEvent = () => {
    const { t } = useTranslation();
    return (_jsxs(_Fragment, { children: [_jsx(QualifiedEventItemsContainer, { children: qualifiedEventItems.map(item => (_jsxs("li", { children: [_jsx(Icon, { title: "check circle icon", color: colors.success, icon: FAS_CHECK_CIRCLE, size: "sm" }), _jsx(Inline, { size: "small" }), t(`common.${item.value}`), _jsx(Inline, { size: "small" })] }, item.id))) }), _jsx(Stack, { size: "small" })] }));
};
export default QualifiedEvent;
